import React from 'react';
import Controls from './Controls';
import LoadingWheel from './LoadingWheel';
import Pagination from 'react-js-pagination';
import FilePlayer from './FilePlayer';
import {MediaLibrary as ML} from 'FW/Models/MediaLibrary';
import {Helper} from '../../../Helpers';
import {Files} from '../../../FW/Models/File';
import _ from 'underscore';
import './MediaLibraryPlayer.scss'

class MediaLibraryTemplate extends React.Component{

  constructor(props){
    super(...arguments);
    let library = FW.store.get('section-' + props.section.get('id') + '-library');
    //let files = FW.store.get('section-' + props.section.get('id') + '-files');
    const files = new Files();
    files.addQuery({
      media_libraries: [library.get('id')]
    });
    if (library.get('site_id') !== FW.store.get('site').get('id')) {
      files.setSite(library.get('site_id'));
    }
    this.state = {
      section: props.section,
      library: library,
      files: files,
      filters: {},
      activePage: 1,
      activeFile: null,
      lastPageSize: props.section.prop('options').page_size || 15,
      libraryID: props.section.get('properties').media_library_id,
      isSermonLibrary: library.get('sermon_library'),
      defaultCategoryID: props.section.prop('options').default_category_id || null,
      defaultYear: props.section.prop('options').default_year || null,
      loading: true
    };
    if (this.props.libraryReturn)
      this.props.libraryReturn(library);
    this.filtersChanged = this.filtersChanged.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    if (FW.inEditor()) {
      this.addButtonToSection();
    }

    let orderBy = this.props.section.prop('options') ? this.props.section.prop('options').sort_by || 'display_date' : 'display_date';
    let orderDir = this.props.section.prop('options') ? this.props.section.prop('options').sort_direction || 'DESC' : 'DESC';
    this.state.files.sortOrder = orderDir;
    this.state.files.sortField = orderBy;
    this.state.files.sort();

    props.section.on('reboot', () => {
      this.state.files.resetSearch();
      this.state.files.setPageSize(props.section.prop('options').page_size || 15, () => {
        this.state.files.trigger('sync');
        let orderBy2 = this.props.section.prop('options') ? this.props.section.prop('options').sort_by || 'display_date' : 'display_date';
        let orderDir2 = this.props.section.prop('options') ? this.props.section.prop('options').sort_direction || 'DESC' : 'DESC';
        this.state.files.sortOrder = orderDir2;
        this.state.files.sortField = orderBy2;
        this.state.files.sort();
        this.setState({
          activePage: this.state.files.pagination ? this.state.files.pagination.number : 1,
          loading: false
        });
      });
    }, this);
  }

  componentDidMount(){
    let libFiles = this.state.files;
    let pageSize = this.props.section.prop('options') ? this.props.section.prop('options').page_size || 15 : 15;
    let orderBy = this.props.section.prop('options') ? this.props.section.prop('options').sort_by || 'display_date' : 'display_date';
    let orderDir = this.props.section.prop('options') ? this.props.section.prop('options').sort_direction || 'DESC' : 'DESC';
    libFiles.on('sync', () => {
      libFiles.sort();
      this.setState({
        files: libFiles,
        loading: false
      });
    }, this);
    let qs = new URLSearchParams(window.location.search);
    const categories = qs.has('categories') && qs.get('categories') !== 'null' ? qs.get('categories') === 'false' ? null : this.state.defaultCategoryID : this.state.defaultCategoryID;
    const defaultYear = this.state.defaultYear ? (this.state.defaultYear + '-01-01 00:00:00|' + this.state.defaultYear + '-12-31 23:59:59') : null;

    const now = (new Date()).toJSON().split('T')[0];
    libFiles.addQuery({
      media_series: qs.get('media_series') && qs.get('media_series') !== 'null' ? qs.get('media_series') : null,
      categories: categories,
      year: qs.has('year') && qs.get('year') !== 'null' ? qs.get('year') === 'false' ? null : defaultYear : defaultYear,
      author: qs.has('author') && qs.get('author') !== 'null' ? qs.get('author') : null,
      reference_range: qs.has('reference_range') && qs.get('reference_range') !== 'null' ? qs.get('reference_range') : null
    }, 'media_controls');

    // ONLY DISPLAY FILES SET TO DISPLAY DATES TODAY OR EARLIER
    if (this.props.section.prop('hide_future_files')) {
      libFiles.addQuery({
        display_date: '1960-01-01|' + now + ' 23:59:59'
      }, 'only_live');
    }

    libFiles.sortByField(orderBy, orderDir);
    libFiles.setPageSize(pageSize);
    this.addFileListeners(this.state.files);
    if (!this.state.library.get('created_at')) {
      this.setState({
        libraryNotFound: true
      });
    }
    this.state.files.on('error', (files, e) => {
      if (e.status === 404) {
        this.setState({
          libraryNotFound: true
        });
      }
    });
  }

  addButtonToSection(){
    let section = this.props.section;
    let user = window.parent.FW.store.get('user') ? window.parent.FW.store.get('user') : null;
    if (user && user.may('edit_media_library', this.state.library)){
      section._editButtons = [{
        title: 'Edit Media Library',
        class: 'glyphicon-pencil',
        type: 'btn-default',
        action: () => {
          this.editLibrary();
        }
      }];
    }
  }

  editLibrary(){
    window.parent.FW.editor.setMode('editLibrary', 'editLibrary', {
      library: this.state.library,
      remount: true,
      onSave: () => {
        this.props.section.reboot();
      }
    });
  }

  componentDidUpdate(){
    let pageSize = this.props.section.prop('options') ? this.props.section.prop('options').page_size || 15 : 15;
    let libraryID = this.props.section.get('properties').media_library_id;
    if (pageSize !== this.state.lastPageSize || libraryID !== this.state.libraryID) {
      let library = ML.findOrCreate({id: libraryID});
      let libFiles = this.state.files;
      this.setState({
        libraryNotFound: false,
        lastPageSize: pageSize,
        loading: true,
        activePage: 1,
        libraryID: libraryID,
        library: library,
        files: libFiles
      }, () => {
        this.addFileListeners(libFiles);
        libFiles.setPageSize(pageSize, () => {
          this.setState({
            loading: false
          });
        });
      });
    }
  }

  addFileListeners(libFiles){
    libFiles.off(null, null, this);
    libFiles.on('sync', () => {
      this.setState({
        files: libFiles,
        loading: false
      });
    }, this);
  }

  componentWillUnmount(){
    this.state.files.off(null, null, this);
    this.props.section.off(null, null, this);
  }

  filtersChanged(filters){
    let qs = new URLSearchParams(window.location.search);
    qs.set('media_series', filters.media_series);
    qs.set('categories', filters.categories);
    qs.set('year', filters.year);
    qs.set('author', filters.author);
    window.history.pushState(filters, null, window.location.pathname + '?' + qs.toString() + window.location.hash);

    const textFilter = filters.title;
    delete filters.title;

    let newFilters = {};
    _.each(filters, (value, key) => {
      if(value === false || value === 'false') {
        newFilters[key] = null;
      } else {
        newFilters[key] = value;
      }
    });

    this.state.files.addQuery(newFilters, 'media_controls', 'and');
    this.setState({
      loading: true,
      activePage: 1,
      filters: filters
    });
    this.state.files.search(textFilter || '', true, 'or', () => {
      this.setState({
        activePage: 1,
        loading: false
      });
    });
  }

  onSort(field, order){
    this.setState({
      loading: true
    });
    this.state.files.sortByField(field, order);
    this.state.files.fetch({reset: true});
  }

  handlePageChange(page){
    this.setState({
      loading: true
    });
    let top = $(this.div).offset().top;
    $('html, body').animate({scrollTop: top - 70 + 'px'}, 500);
    this.state.files.getPage(page, () => {
      this.setState({
        activePage: page,
        loading: false
      });
    });
  }

  render(){
    const options = this.state.section.prop('options') || {};
    const isSermonLibrary = !!this.state.library.get('sermon_library');
    const showPassageSearch = !!options.show_passage_search_field;
    const showPassageAsSubtitle = !!options.show_passage_as_subtitle;
    const openInNewTab = this.state.section.prop('open_in_new_tab');
    const customColors = this.state.section.ls('use_custom_colors') ? {
      author: {
        color: this.state.section.ls('author_color')
      },
      title: {
        color: this.state.section.ls('title_color'),
        fontSize: this.state.section.ls('title_font_size') + 'px'
      },
      date: {
        color: this.state.section.ls('date_color')
      },
      description: {
        color: this.state.section.ls('description_color')
      },
      background: {
        background: this.state.section.ls('background_color') ? Helper.convertHexToRGBA(this.state.section.ls('background_color'), this.state.section.ls('background_opacity') * 100) : null
      },
      backgroundHover: {
        background: this.state.section.ls('background_hover_color') ? Helper.convertHexToRGBA(this.state.section.ls('background_hover_color'), this.state.section.ls('background_hover_opacity') * 100) : null
      },
      backgroundActive: {
        background: this.state.section.ls('background_active_color') ? this.state.section.ls('background_active_color') : null
      },
      overlay: {
        background: this.state.section.ls('overlay_color') ? Helper.convertHexToRGBA(this.state.section.ls('overlay_color'), this.state.section.ls('overlay_opacity') * 100) : null
      }
    } : null;
    const Component = this.props.Component;

    let files = this.state.files && this.state.files.models ? this.state.files.getCurrentPage().map((file) => {
      return <Component active={file.get('id') === (this.props.currentFile ? this.props.currentFile.get('id') : false)} onClick={this.props.onFileClick} options={options} contain_image={this.state.section.prop('contain_image')} hide_dates={this.state.section.prop('hide_dates')} openInNewTab={openInNewTab} customColors={customColors} showPassageAsSubtitle={showPassageAsSubtitle} showSubtitle={this.state.section.prop('show_subtitle')} showDescription={this.state.section.prop('show_description')} showThumbnail={this.state.section.prop('show_thumbnails')} file={file} key={file.get('id')} />;
    }) : [];
    let pagination = this.state.files ? this.state.files.pagination : {};
    const singleFile = options.page_size === 1 ? 'single-file' : '';
    const fivePerRow = this.state.section.ls('five_per_row') ? true : false;
    return (
      <div className={(fivePerRow ? 'media-section-player ' : '') + "FWMediaSection standard-layout " + singleFile} style={options.font ? {fontFamily: options.font} : {}} ref={(c) => {this.div = c;}}>
        {this.state.libraryNotFound ? <div style={{paddingTop: 150, paddingBottom: 150, paddingLeft: 10, paddingRight: 10, textAlign: 'center', background: '#ccc', borderRadius: 5, marginLeft: 20, marginRight: 20}}>
          <p className="lead">Media Library Not Found</p>
          {FW.inEditor() ? <p className="lead">You can edit this section&apos;s properties to select a library.</p> : null}
        </div> : <div>
          <div>
            <FilePlayer file={this.state.activeFile} />
          </div>

          {this.state.files && !this.props.section.prop('hide_control_bar') ?
            <div>
              <Controls isSermonLibrary={isSermonLibrary} showPassageSearch={showPassageSearch} hideRssButton={this.props.section.prop('hide_rss_button')} section={this.props.section} library={this.state.library} onChange={this.filtersChanged} onSort={this.onSort} />
            </div>
           : null}

          <div className="files" style={{position: 'relative', width: '100%'}}>
            {files}
            {this.state.activePage === 1 && files.length === 0 && !this.state.loading ? <div style={{width: '100%', padding: 50, textAlign: 'center'}}>
              <p className="lead">This library does not yet have any files.</p>
              {FW.inEditor() ? <p className="lead" style={{fontSize: '1.2em'}}>You can add files to this library by hovering over it and clicking the
                &quot;Edit Media Library&quot; pencil on the upper-right.</p> : null}
            </div> : null}
            {this.props.section.prop('hide_pagination') ? null : <div style={{textAlign: 'center', width: '100%'}}>
              <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={pagination.size || 10}
                totalItemsCount={typeof pagination.total !== 'undefined' ? pagination.total : 10}
                pageRangeDisplayed={options.num_pages_listed || 15}
                onChange={this.handlePageChange}
              />
            </div>}

            {this.state.loading ? <div style={{position: 'absolute', width: 'calc(100% - 20px)', height: 'calc(100% - 20px)', margin: '10px', background: 'rgba(93, 93, 93, 0.61)', borderRadius: '5px'}}>
              <LoadingWheel style={{top: 100}} />
            </div> : null}
          </div>
        </div>}
      </div>
    );
  }

}

export default MediaLibraryTemplate;
